var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('App',[_c('Header'),_vm._v(" "),_c('main',{class:{ 'is-fixed': _vm.isFixed }},[_vm._t("default")],2),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('dark-light-switch'),_vm._v(" "),_c('CallFab'),_vm._v(" "),_c('BottomNav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }